import { render, staticRenderFns } from "./TileCategoryComponent.vue?vue&type=template&id=5a9046d8&scoped=true&"
import script from "./TileCategoryComponent.vue?vue&type=script&lang=ts&"
export * from "./TileCategoryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TileCategoryComponent.vue?vue&type=style&index=0&id=5a9046d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9046d8",
  null
  
)

export default component.exports